<script>
import Layout from '@/views/layouts/main';
import appConfig from '@/app.config';
import LoadingIcon from '@/components/Loading/main.vue';
import Footer from '@/components/Footer/main.vue';
import Multiselect from '@/components/Multiselect/main.vue';
import TextareaComponent from '@/components/Textarea/main.vue';

import { masterComputed, masterMethods, faqMethods } from '@/state/helpers';
import { checkPermission } from '@/utils/handlers';
import { keyMaster } from '@/config/constants';
import { showMessage } from '@/utils/messages.js';
import { InputCheckBox, InputRadio } from '@/components/Input';
import { LIST_APPLICATION_CLOUD, convertNtoBr } from '@/views/pages/masters/template/constants';
import { initFormFaq, initInfoAnswer, configFormFaq } from './constants';

export default {
    page: {
        title: 'FAQ新規登録',
        meta: [{ name: 'description', content: appConfig.description }]
    },
    components: {
        LoadingIcon,
        Layout,
        Footer,
        InputCheckBox,
        InputRadio,
        Multiselect,
        TextareaComponent
    },
    beforeRouteEnter(to, from, next) {
        if (to.query.id) {
            if (!checkPermission('faq.edit')) {
                next({ name: 'errorPage' });
            }
            next();
        } else {
            if (!checkPermission('faq.register')) {
                next({ name: 'errorPage' });
            }
            next();
        }
    },
    data() {
        return {
            index: 1,
            loading: false,
            id: this.$route.query.id,
            answerDuplicate: {},
            form: initFormFaq(),

            listSheetFAQ: [],
            listDataCPTypes: [],
            listApplicationType: [],
            listDataMasterCondition1: [],
            listDataMasterCondition2: [],
            submitted: false,
            submit: false,
            recivedIDCP: '',
            listShortCode: [...LIST_APPLICATION_CLOUD()],
            indexBlur: 0,
            activeTextareaId: null,
            lastCursorPosition: 0
        };
    },
    computed: {
        ...masterComputed
    },
    validations: {
        form: configFormFaq()
    },

    watch: {
        'form.campaign_type.id': function () {
            if (this.form.campaign_type.id !== this.recivedIDCP) {
                this.recivedIDCP = this.form.campaign_type.id;
                if (this.form.application_type.length) this.form.application_type = [];
            }

            if (this.$route.query.id && this.form.application_type.length) return;
            const findApplicationType = this.listDataCPTypes.find((item) => item.id === this.form.campaign_type.id);
            if (findApplicationType) {
                this.listApplicationType = findApplicationType.data;
            }
        },

        'form.application_type': function () {
            this.addForm(this.form.application_type);
            if (this.form.application_type.length !== this.form.categories.length) {
                this.form.categories = this.form.categories.filter((item) => this.form.application_type.find((el) => el === item.category.id));
            }
        }
    },
    methods: {
        checkPermission,
        ...masterMethods,
        ...faqMethods,
        convertNtoBr,
        // call api

        async getListMasterTypes() {
            this.loading = true;
            try {
                const data = await this.listMaster(keyMaster['campaign.type']);
                this.listDataCPTypes = data;
            } catch (error) {
                console.log('error', error);
            } finally {
                this.loading = false;
            }
        },
        checkPermiss(listRole) {
            return checkPermission(listRole);
        },
        getDetail(id) {
            this.loading = true;
            this.detailFaq(id).then((data) => {
                const findApplicationType = this.listDataCPTypes.find((item) => item.id === data.campaign_type.id);
                if (findApplicationType) {
                    this.listApplicationType = findApplicationType.data;
                }
                this.recivedIDCP = data.campaign_type.id;
                this.form = {
                    ...initFormFaq(data),
                    answers: data.answers?.map((item) => {
                        item.make_id = item.id;
                        return item;
                    }) || [initInfoAnswer()],
                    application_type: data.categories.map((item) => item.category.id),
                    categories: []
                };

                for (let i = 0; i < data.categories.length; i++) {
                    const findArrayCondition1 = this.listApplicationType.find((item) => item.id === data.categories[i].category.id);
                    let obj = {
                        id: data.categories[i].id,
                        category: {
                            id: data.categories[i].category.id
                        },
                        listDataMasterCondition1: this.onHandleFilterValueOther(findArrayCondition1.data),
                        category_conditions: [],
                        application_condition_1: []
                    };
                    data.categories[i].category_conditions.forEach((item) => {
                        // let dataObject = []
                        findArrayCondition1.data.forEach((jtem) => {
                            if (jtem.id == item.application_condition_1.id) {
                                obj.category_conditions.push({
                                    application_condition_1: item.application_condition_1,
                                    application_condition_2_ids: item.application_condition_2_ids.map((item) => item.id),
                                    answer_ids: item.answers_ids.length <= 0 ? [null] : item.answers_ids,
                                    listDataMasterCondition2: this.onHandleFilterValueOther(jtem.data)
                                });
                                obj.application_condition_1.push(item.application_condition_1.id);
                            }
                        });
                    });

                    this.form.categories.push(obj);
                    this.loading = false;
                }
            });
        },

        async getListMasterSheets() {
            this.loading = true;
            try {
                const data = await this.listMaster(keyMaster['faq_master.sheets']);
                this.listSheetFAQ = data;
            } catch (error) {
                console.log('error', error);
            } finally {
                this.loading = false;
            }
        },
        // handle Form
        resetForm() {
            this.recivedIDCP = '';
            this.form = initFormFaq();
            this.listApplicationType = this.listDataMasterCondition1 = this.listDataMasterCondition2 = [];
        },
        addCommonAnswers() {
            this.form.answers.push(initInfoAnswer());
        },
        removeCommonAnswers(k) {
            this.form.answers.splice(k, 1);
        },
        subString(string) {
            if (string) {
                if (string.length > 30) return string.substring(0, 30) + '...';
                return string;
            }
            return '';
        },
        addAnswers(params, k) {
            for (let i = 0; i < this.form.categories.length; i++) {
                if (this.form.categories[i].category.id === params) {
                    this.form.categories[i].category_conditions[k].answer_ids.push(null);
                }
            }
        },

        removeAnswers(params, k, k1) {
            for (let i = 0; i < this.form.categories.length; i++) {
                if (this.form.categories[i].category.id === params) {
                    this.form.categories[i].category_conditions[k].answer_ids.splice(k1, 1);
                }
            }
        },

        removeBox(params) {
            const findIdx = this.form.application_type.findIndex((item) => item === params);
            this.form.application_type.splice(findIdx, 1);
        },

        addForm(paramId) {
            for (let i = 0; i < paramId.length; i++) {
                const findArrayCondition1 = this.listApplicationType.find((item) => item.id === paramId[i]);
                if (!this.form.categories.length) {
                    this.form.categories.push({
                        category: {
                            id: paramId[i]
                        },
                        category_conditions: [],
                        application_condition_1: [],
                        validate_condition_1: false,
                        listDataMasterCondition1: this.onHandleFilterValueOther(findArrayCondition1.data),
                        application_condition_2_id: [],
                        answers: [initInfoAnswer()]
                    });
                } else {
                    const findIdAlike = this.form.categories.find((item) => item.category.id === paramId[i]);
                    if (!findIdAlike) {
                        this.form.categories.push({
                            category: {
                                id: paramId[i]
                            },
                            category_conditions: [],
                            listDataMasterCondition1: this.onHandleFilterValueOther(findArrayCondition1.data),
                            application_condition_1: [],
                            validate_condition_1: false,
                            application_condition_2_id: [],
                            answers: [initInfoAnswer()]
                        });
                    }
                }
            }
        },
        handleChangeCondition1() {
            for (let i = 0; i < this.form.categories.length; i++) {
                this.form.categories[i].application_condition_1.forEach((item) => {
                    let arr = JSON.parse(JSON.stringify(this.form.categories[i].category_conditions));
                    const findIdAlike = arr.find((i) => i.application_condition_1 && i.application_condition_1.id === item);
                    if (!findIdAlike) {
                        this.form.categories[i].listDataMasterCondition1.forEach((xtem) => {
                            if (xtem.id == item) {
                                this.form.categories[i].category_conditions.push({
                                    application_condition_1: { id: item },
                                    listDataMasterCondition2: this.onHandleFilterValueOther(xtem.data),
                                    application_condition_2_ids: [],
                                    answer_ids: [null]
                                });
                            }
                        });
                    }
                });

                this.form.categories[i].category_conditions = this.form.categories[i].category_conditions.filter((item) => {
                    return this.form.categories[i].application_condition_1.some((x) => {
                        return item.application_condition_1 && x === item.application_condition_1.id;
                    });
                });
            }
        },

        handleValidate() {
            let check = true;
            if (!this.form.sheet.id || !this.form.application_type.length) {
                check = false;
            }

            if (this.form.has_answer_default) {
                if (this.form.answers.length) {
                    for (let y = 0; y < this.form.answers.length; y++) {
                        if (!this.form.answers[y].answer) {
                            check = false;
                        }
                    }
                }
            }

            for (let i = 0; i < this.form.categories.length; i++) {
                if (!this.form.categories[i].application_condition_1) {
                    check = false;
                }

                if (!this.form.has_answer_default) {
                    for (let x = 0; x < this.form.categories[i].category_conditions.length; x++) {
                        for (let y = 0; y < this.form.categories[i].category_conditions[x].answer_ids.length; y++) {
                            if (!this.form.categories[i].category_conditions[x].answer_ids[y]?.answer) {
                                check = false;
                            }
                        }
                    }
                }
            }

            return check;
        },
        checkDisabel(dt, it) {
            let i = dt.findIndex((x) => {
                return x?.answer && x?.answer == it;
            });
            if (i >= 0) return true;
            else return false;
        },
        renderTitleBox(idCategory) {
            return this.listApplicationType.find((item) => item.id === idCategory)?.value;
        },
        renderTitleBoxChild(idCategoryChild, data) {
            return data.find((item) => item.id === idCategoryChild)?.value;
        },
        // send serve
        formSubmit() {
            this.submitted = true;
            this.form.categories.forEach((item) => {
                if (item.application_condition_1 && item.application_condition_1.length <= 0) {
                    return true;
                }
            });

            this.$v.$touch();
            const isValidate = this.handleValidate();
            const isValidDuplicateAnswer = this.checkDuplicateAnswers();
            if (!isValidate || this.$v.form.answers.$error || isValidDuplicateAnswer) return;
            this.register();
        },
        validateDuplicate(k, answerValue) {
            this.form.categories.forEach((item) => {
                item.category_conditions.forEach((jtem) => {
                    jtem.answer_ids.forEach((ktem) => {
                        let i = this.form.answers.findIndex((atem) => {
                            return atem.answer == ktem?.answer;
                        });
                        if (i < 0) {
                            if (ktem?.answer) {
                                ktem.answer = '';
                            }
                        }
                    });
                });
            });
            return this.form.answers.some((item, i) => {
                return i !== k && item.answer === answerValue;
            });
        },
        checkDuplicateAnswers() {
            this.answerDuplicate = {};
            let hasDuplicate = false;
            this.form.answers.forEach((item, k) => {
                if (this.validateDuplicate(k, item?.answer)) {
                    this.answerDuplicate[k] = true;
                    hasDuplicate = true;
                }
            });
            return hasDuplicate;
        },

        register() {
            if (this.form.question && !this.loading) {
                let obj = JSON.parse(JSON.stringify(this.form));
                delete obj.application_type;
                // loại bỏ 1 số trường
                let check = false;
                obj.categories.filter((x) => {
                    if (x.application_condition_1 && x.application_condition_1.length <= 0) {
                        check = true;
                    }
                    x.category_conditions = x.category_conditions.map((item) => {
                        delete item.listDataMasterCondition1;
                        delete item.listDataMasterCondition2;
                        return item;
                    });
                    delete x.application_condition_1;
                    delete x.application_condition_2_id;
                    delete x.answers;
                    delete x.listDataMasterCondition1;
                });
                if (check) return;
                this.loading = true;
                if (this.$route.query.id) {
                    obj.id = this.$route.query.id;
                    this.updateFaqs(obj).then((data) => {
                        if (data.code == 200) {
                            showMessage(data.code, this.$bvToast, 'FAQが更新されました。');
                            this.getDetail(this.$route.query.id);
                        }
                        if (data.code != 200) {
                            showMessage(data.code, this.$bvToast, this.$t(data.message));
                            this.loading = false;
                        }
                    });
                } else {
                    this.loading = true;
                    this.registerFaq(obj).then((data) => {
                        if (data.code == 200) {
                            this.$router.push({ path: '/faq/view', query: { id: data.data.id } }).then(() => {
                                showMessage(data.code, this.$bvToast, 'FAQが登録されました。');
                            });
                        }
                        if (data.code != 200) {
                            showMessage(data.code, this.$bvToast, this.$t(data.message));
                            this.loading = false;
                        }
                    });
                }
            }
        },
        updateCursorPosition(event) {
            const textarea = event.target;
            if (textarea && (textarea.tagName === 'TEXTAREA' || textarea.tagName === 'INPUT')) {
                this.activeTextareaId = textarea.id;
                this.lastCursorPosition = textarea.selectionStart;
            }
        },
        insertTextAtPosition(targetId, text, dropEvent = null) {
            let pos = this.lastCursorPosition;
            if (dropEvent && dropEvent.target) {
                pos = dropEvent.target.selectionStart ?? pos;
            }

            if (targetId === 'question') {
                const currentText = this.form.question || '';
                this.form.question = currentText.substring(0, pos) + text + currentText.substring(pos);
                this.lastCursorPosition = pos + text.length;
            } else if (targetId === 'secretariatNotices') {
                const currentText = this.form.extension.secretariat_notices || '';
                this.form.extension.secretariat_notices = currentText.substring(0, pos) + text + currentText.substring(pos);
                this.lastCursorPosition = pos + text.length;
            } else if (targetId === 'messageTo') {
                const currentText = this.form.extension.message_to || '';
                this.form.extension.message_to = currentText.substring(0, pos) + text + currentText.substring(pos);
                this.lastCursorPosition = pos + text.length;
            } else {
                this.form.answers.forEach((item, i) => {
                    if (targetId === `answer-${i}`) {
                        const currentText = this.form.answers[i].answer || '';
                        this.form.answers[i].answer = currentText.substring(0, pos) + text + currentText.substring(pos);
                        this.lastCursorPosition = pos + text.length;
                    } else if (targetId === `pattern-${i}-${this.indexBlur}`) {
                        const currentText = this.form.answers[i].pattern || '';
                        this.form.answers[i].pattern = currentText.substring(0, pos) + text + currentText.substring(pos);
                        this.lastCursorPosition = pos + text.length;
                    }
                });
            }
        },
        clickInsertShortCode(text) {
            if (this.activeTextareaId) {
                const targetId = this.activeTextareaId;
                const pos = this.lastCursorPosition;
                this.insertTextAtPosition(targetId, text);
                this.$nextTick(() => {
                    const el = document.getElementById(targetId);
                    if (el) {
                        el.focus();
                        const newCursorPos = pos + text.length;
                        el.setSelectionRange(newCursorPos, newCursorPos);
                        this.lastCursorPosition = newCursorPos;
                    }
                });
            }
        },
        handleGlobalClick(event) {
            const target = event.target;
            if (!target) return;
            const isTextInput =
                target.tagName === 'TEXTAREA' ||
                (target.tagName === 'INPUT' && !['checkbox', 'radio', 'button', 'submit', 'reset', 'file'].includes(target.type));
            const isInsideShortcodeTable = target.closest('.col_right') !== null;
            if (!isTextInput && !isInsideShortcodeTable) {
                this.activeTextareaId = null;
                this.lastCursorPosition = 0;
            }
        },

        handleGetDetail() {
            this.$router.push({
                path: '/faq/view',
                query: {
                    id: this.$route.query.id
                }
            });
        },

        onHandleFilterValueOther(listConditions) {
            return listConditions?.filter((dataC) => dataC.value !== 'その他');
        },

        onHandleOpenAnswer(chAnswer_ids) {
            this.form.answers.forEach((item) => {
                item.$isDisabled = this.checkDisabel(chAnswer_ids, item.answer);
            });
        },

        isAllSelectedCondition1(ct) {
            if (!ct.listDataMasterCondition1 || ct.listDataMasterCondition1.length === 0) return false;
            return (ct.application_condition_1 || []).length === ct.listDataMasterCondition1.length;
        },

        toggleSelectAllCondition1(ct, checked) {
            if (checked) {
                ct.application_condition_1 = ct.listDataMasterCondition1.map((item) => item.id);
            } else {
                ct.application_condition_1 = [];
            }
            this.handleChangeCondition1();
        },

        isAllSelectedCondition2(ch) {
            if (!ch.listDataMasterCondition2 || ch.listDataMasterCondition2.length === 0) return false;
            return (ch.application_condition_2_ids || []).length === ch.listDataMasterCondition2.length;
        },

        toggleSelectAllCondition2(ch, checked) {
            if (checked) {
                ch.application_condition_2_ids = ch.listDataMasterCondition2.map((item) => item.id);
            } else {
                ch.application_condition_2_ids = [];
            }
        }
    },
    async mounted() {
        await this.getListMasterTypes();
        this.getListMasterSheets();
        if (this.$route.query.id) {
            this.getDetail(this.$route.query.id);
        }
        document.addEventListener('click', this.handleGlobalClick);
    },
    beforeRouteUpdate(to, from, next) {
        const queryId = to.query.id;
        if (!queryId) {
            this.resetForm();
        }
        next();
    },
    beforeDestroy() {
        this.recivedIDCP = '';
        document.removeEventListener('click', this.handleGlobalClick);
    }
};
</script>

<template>
    <Layout>
        <template v-if="!loading">
            <div class="col-lg-12">
                <div class="card mb-0">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-1"></div>
                            <div class="col-sm-12 row flex-nowrap">
                                <div class="col-sm-6 col_left">
                                    <form class="needs-validation" @submit.prevent="formSubmit" autocomplete="off">
                                        <div class="form-group">
                                            <label class="col-sm-3 mw--form" for="validationCustom05"
                                                >{{ $t('faq.sheets') }}
                                                <span class="text-danger">*</span>
                                            </label>
                                            <div class="col-sm-9">
                                                <div class="d-flex flex-wrap">
                                                    <div style="min-width: 100px" v-for="item in listSheetFAQ" :key="item.id">
                                                        <InputRadio
                                                            class="mr-4 py-1"
                                                            :model.sync="form.sheet.id"
                                                            :id="`radio_sheet${item.id}`"
                                                            :value="item.id"
                                                            :label="item.value"
                                                        />
                                                    </div>
                                                </div>
                                                <span
                                                    :class="{
                                                        'is-invalid': submitted && $v.form.sheets.$error
                                                    }"
                                                ></span>
                                                <div v-if="submitted && $v.form.sheets.$error" class="invalid-feedback">
                                                    <span v-if="!$v.form.sheets.required && !form.sheet.id">{{
                                                        $t('validateField.requiredSelect', {
                                                            field: $t('faq.sheets')
                                                        })
                                                    }}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label class="col-sm-3 mw--form" for="validationCustom05"
                                                >{{ $t('faq.campaignType') }}
                                                <span class="text-danger">*</span>
                                            </label>
                                            <div class="col-sm-9">
                                                <div class="d-flex">
                                                    <div v-for="cpt in listDataCPTypes" :key="cpt.id + 's'">
                                                        <InputRadio
                                                            class="mr-4"
                                                            :model.sync="form.campaign_type.id"
                                                            :id="`radio${cpt.id}`"
                                                            :value="cpt.id"
                                                            :label="cpt.value"
                                                        />
                                                    </div>
                                                </div>
                                                <span
                                                    :class="{
                                                        'is-invalid': submitted && $v.form.campaign_types.$error
                                                    }"
                                                ></span>
                                                <div v-if="submitted && $v.form.campaign_types.$error" class="invalid-feedback">
                                                    <span v-if="!$v.form.campaign_types.required && !form.campaign_type.id">{{
                                                        $t('validateField.requiredSelect', {
                                                            field: $t('faq.campaignType')
                                                        })
                                                    }}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-if="form?.campaign_type?.id" class="form-group">
                                            <label class="col-sm-3 mw--form" for="validationCustom05"
                                                >{{ $t('faq.applicationType') }}
                                                <span v-if="listApplicationType.length > 0" class="text-danger">*</span>
                                            </label>
                                            <div class="col-sm-9">
                                                <div class="d-flex flex-wrap">
                                                    <div style="min-width: 100px" v-for="apTypes in listApplicationType" :key="apTypes.id">
                                                        <InputCheckBox
                                                            class="mr-4 py-1"
                                                            :model.sync="form.application_type"
                                                            :id="`check_app${apTypes.id}`"
                                                            :value="apTypes.id"
                                                            :label="apTypes.value"
                                                        />
                                                    </div>
                                                </div>
                                                <span
                                                    :class="{
                                                        'is-invalid': submitted && $v.form.application_type.$error && listApplicationType.length > 0
                                                    }"
                                                ></span>
                                                <div
                                                    v-if="submitted && $v.form.application_type.$error && listApplicationType.length > 0"
                                                    class="invalid-feedback"
                                                >
                                                    <span v-if="!$v.form.application_type.required && listApplicationType.length > 0">{{
                                                        $t('validateField.requiredSelect', {
                                                            field: $t('faq.applicationType')
                                                        })
                                                    }}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label class="col-sm-3 mw--form" for="question"
                                                >{{ $t('faq.question') }}
                                                <span class="text-danger">*</span>
                                            </label>
                                            <div class="col-sm-9">
                                                <textarea
                                                    id="question"
                                                    v-model="form.question"
                                                    class="form-control"
                                                    rows="4"
                                                    :class="{
                                                        'is-invalid': submitted && $v.form.question.$error
                                                    }"
                                                    :placeholder="$t('faq.placeholderQuestion')"
                                                    @click="updateCursorPosition"
                                                    @keyup="updateCursorPosition"
                                                    @blur="updateCursorPosition"
                                                ></textarea>
                                                <div v-if="submitted && $v.form.question.$error" class="invalid-feedback">
                                                    <span v-if="!$v.form.question.required">{{
                                                        $t('validateField.required', {
                                                            field: $t('faq.question')
                                                        })
                                                    }}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label class="col-sm-6 mw--form" for="question">{{ $t('faq.secretariatNotices') }} </label>
                                            <div class="col-sm-9">
                                                <TextareaComponent
                                                    :id="`secretariatNotices`"
                                                    :model.sync="form.extension.secretariat_notices"
                                                    :rows="`4`"
                                                    :config="{
                                                        error: submitted && $v.form.extension.secretariat_notices.$error
                                                    }"
                                                    @click.native="updateCursorPosition"
                                                    @keyup.native="updateCursorPosition"
                                                    @blur.native="updateCursorPosition"
                                                >
                                                    <div v-if="$v.form.extension.secretariat_notices.$error" class="d-block invalid-feedback">
                                                        <span v-if="!$v.form?.extension?.secretariat_notices?.required">
                                                            {{
                                                                $t('validateField.required', {
                                                                    field: $t('faq.secretariatNotices')
                                                                })
                                                            }}
                                                        </span>
                                                    </div>
                                                </TextareaComponent>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class="col-sm-3 mw--form" for="question">{{ $t('faq.messageTo') }} </label>
                                            <div class="col-sm-9">
                                                <TextareaComponent
                                                    :id="`messageTo`"
                                                    :model.sync="form.extension.message_to"
                                                    :rows="`4`"
                                                    :config="{
                                                        error: submitted && $v.form.extension.message_to.$error
                                                    }"
                                                    @click.native="updateCursorPosition"
                                                    @keyup.native="updateCursorPosition"
                                                    @blur.native="updateCursorPosition"
                                                >
                                                    <div v-if="$v.form.extension.message_to.$error" class="d-block invalid-feedback">
                                                        <span v-if="!$v.form?.extension?.message_to?.required">
                                                            {{
                                                                $t('validateField.required', {
                                                                    field: $t('faq.messageTo')
                                                                })
                                                            }}
                                                        </span>
                                                    </div>
                                                </TextareaComponent>
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label class="col-sm-3 mw--form" for="validationCustom05">{{ $t('faq.commonAsk') }} </label>
                                            <div class="col-sm-9">
                                                <InputCheckBox
                                                    :model.sync="form.has_answer_default"
                                                    :id="`check-has_answer_default`"
                                                    :value="form.has_answer_default"
                                                    :label="``"
                                                />
                                            </div>
                                        </div>
                                        <div class="form-group" v-for="(pASk, k) in form.answers" :key="'p' + k">
                                            <label class="col-sm-3 mw--form" :for="`answer-${k}`">回答 <span class="text-danger">*</span> </label>
                                            <div class="col-sm-9">
                                                <div class="mb-3">
                                                    <div class="d-flex align-items-center" style="column-gap: 15px">
                                                        <div class="w-100">
                                                            <textarea
                                                                :id="`answer-${k}`"
                                                                v-model="form.answers[k].answer"
                                                                class="form-control"
                                                                rows="4"
                                                                @change="checkDuplicateAnswers"
                                                                :class="{
                                                                    'is-invalid':
                                                                        (submitted && $v.form.answers.$each[k].answer.$error) || answerDuplicate[k]
                                                                }"
                                                                @click="updateCursorPosition"
                                                                @keyup="updateCursorPosition"
                                                                @blur="updateCursorPosition"
                                                            ></textarea>
                                                            <div v-if="submitted && $v.form.answers.$each[k].answer.$error" class="invalid-feedback">
                                                                <span v-if="!form.answers[k].answer">{{
                                                                    $t('validateField.required', {
                                                                        field: '回答'
                                                                    })
                                                                }}</span>
                                                            </div>
                                                            <div v-if="form.answers[k].answer && answerDuplicate[k]" class="invalid-feedback">
                                                                <span>重複回答を入力しないようにご注意ください。</span>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <button
                                                                v-if="k === 0"
                                                                type="button"
                                                                class="btn btn-sm btn-outline-info"
                                                                style="border-radius: 50%"
                                                                @click="addCommonAnswers()"
                                                            >
                                                                <i class="fa fa-plus"></i>
                                                            </button>
                                                            <button
                                                                v-else
                                                                type="button"
                                                                class="btn btn-outline-danger btn-sm"
                                                                style="border-radius: 50%"
                                                                @click="removeCommonAnswers(k)"
                                                            >
                                                                <i class="fa fa-minus"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <label class="col-sm-3 mw--form" :for="`pattern-${k}`">{{ $t('faq.patternAnswer') }}</label>
                                            <div class="col-sm-9">
                                                <div class="mb-3">
                                                    <div class="d-flex align-items-center" style="column-gap: 15px">
                                                        <div class="w-100">
                                                            <textarea
                                                                :id="`pattern-${k}-${indexBlur}`"
                                                                v-model="form.answers[k].pattern"
                                                                class="form-control"
                                                                rows="4"
                                                                @change="
                                                                    () => {
                                                                        indexBlur++;
                                                                    }
                                                                "
                                                                :class="{
                                                                    'is-invalid': submitted && $v.form.answers.$each[k].pattern.$error
                                                                }"
                                                                @click="updateCursorPosition"
                                                                @keyup="updateCursorPosition"
                                                                @blur="updateCursorPosition"
                                                            ></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Loop Form  -->
                                        <div v-if="form.application_type.length" class="px-2 pr-3">
                                            <div
                                                v-for="(ct, dx) in form.categories"
                                                :key="dx"
                                                class="py-3 mt-3"
                                                style="box-shadow: rgba(0, 0, 0, 0.2) 0px 5px 15px; border-radius: 10px"
                                            >
                                                <label class="col-sm-3 mw--form" for="validationCustom05"
                                                    >{{ renderTitleBox(ct.category.id) }}
                                                </label>

                                                <div class="text-right">
                                                    <button
                                                        type="button"
                                                        class="btn btn-outline-danger btn-sm mr-3 mb-2"
                                                        style="border-radius: 50%"
                                                        @click="removeBox(ct.category.id)"
                                                    >
                                                        <i class="fa fa-trash"></i>
                                                    </button>
                                                </div>
                                                <div class="form-group">
                                                    <label class="col-sm-3 mw--form" for="validationCustom05"
                                                        >{{ $t('faq.condition1') }}
                                                        <span class="text-danger">*</span>
                                                    </label>
                                                    <div class="col-sm-9">
                                                        <div
                                                            class="mb-2"
                                                            v-if="ct.listDataMasterCondition1 && ct.listDataMasterCondition1.length > 0"
                                                        >
                                                            <InputCheckBox
                                                                :model="isAllSelectedCondition1(ct)"
                                                                :id="`${dx}check_all_cond1`"
                                                                :value="true"
                                                                :label="$t('pageCampaign.checkAll')"
                                                                @change="toggleSelectAllCondition1(ct, $event)"
                                                            />
                                                        </div>
                                                        <div class="d-flex flex-wrap">
                                                            <div
                                                                style="min-width: 100px"
                                                                v-for="apTypes in ct.listDataMasterCondition1"
                                                                :key="apTypes.id"
                                                            >
                                                                <InputCheckBox
                                                                    class="mr-4 py-1"
                                                                    :model.sync="ct.application_condition_1"
                                                                    :id="`${dx}check_appss${apTypes.id}`"
                                                                    :value="apTypes.id"
                                                                    :label="apTypes.value"
                                                                    @change="handleChangeCondition1"
                                                                />
                                                            </div>
                                                        </div>
                                                        <span
                                                            :class="{
                                                                'is-invalid':
                                                                    submitted && ct.application_condition_1 && ct.application_condition_1.length == 0
                                                            }"
                                                        ></span>
                                                        <div
                                                            v-if="submitted && ct.application_condition_1 && ct.application_condition_1.length == 0"
                                                            class="invalid-feedback"
                                                        >
                                                            <span v-if="ct.application_condition_1 && ct.application_condition_1.length == 0">{{
                                                                $t('validateField.requiredSelect', {
                                                                    field: $t('faq.condition1')
                                                                })
                                                            }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-for="(ch, k) in ct.category_conditions" :key="`ch${k}`">
                                                    <hr />
                                                    <label class="" style="padding-left: 15px">{{
                                                        renderTitleBoxChild(ch.application_condition_1.id, ct.listDataMasterCondition1)
                                                    }}</label>
                                                    <div class="form-group">
                                                        <label class="col-sm-3 mw--form" for="validationCustom05">{{ $t('faq.condition2') }} </label>
                                                        <div class="col-sm-9">
                                                            <div
                                                                class="mb-2"
                                                                v-if="ch.listDataMasterCondition2 && ch.listDataMasterCondition2.length > 0"
                                                            >
                                                                <InputCheckBox
                                                                    :model="isAllSelectedCondition2(ch)"
                                                                    :id="`${dx}-${k}check_all_cond2`"
                                                                    :value="true"
                                                                    :label="$t('pageCampaign.checkAll')"
                                                                    @change="toggleSelectAllCondition2(ch, $event)"
                                                                />
                                                            </div>
                                                            <div class="d-flex flex-wrap">
                                                                <div
                                                                    style="min-width: 100px"
                                                                    v-for="cdt2 in ch.listDataMasterCondition2"
                                                                    :key="cdt2.id"
                                                                >
                                                                    <InputCheckBox
                                                                        class="mr-4 py-1"
                                                                        :model.sync="ch.application_condition_2_ids"
                                                                        :id="`${k}check_condition2${cdt2.id}`"
                                                                        :value="cdt2.id"
                                                                        :label="cdt2.value"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-if="!form.has_answer_default" class="form-group">
                                                        <label class="col-sm-3 mw--form" for="validationCustom052222"
                                                            >{{ $t('faq.ask') }}
                                                            <span class="text-danger">*</span>
                                                        </label>
                                                        <div class="col-sm-9">
                                                            <div>
                                                                <div v-for="(pASk, k1) in ch.answer_ids" :key="'p' + k1" class="mb-3">
                                                                    <div class="d-flex align-items-center" style="column-gap: 15px">
                                                                        <div class="w-100">
                                                                            <Multiselect
                                                                                :id="`select-answer-${k1}-${k}-${dx}`"
                                                                                :value.sync="ch.answer_ids[k1]"
                                                                                :options="form.answers"
                                                                                :config="{
                                                                                    trackBy: 'make_id',
                                                                                    label: 'answer',
                                                                                    error: submitted && !ch.answer_ids[k1]?.answer,
                                                                                    isRemove: true
                                                                                }"
                                                                                @open="onHandleOpenAnswer(ch.answer_ids)"
                                                                            />
                                                                            <div
                                                                                v-if="submitted && !ch.answer_ids[k1]?.answer"
                                                                                class="invalid-feedback"
                                                                            >
                                                                                <span>{{
                                                                                    $t('validateField.required', {
                                                                                        field: $t('faq.ask')
                                                                                    })
                                                                                }}</span>
                                                                            </div>
                                                                        </div>
                                                                        <div>
                                                                            <button
                                                                                v-if="k1 === 0"
                                                                                type="button"
                                                                                class="btn btn-sm btn-outline-info"
                                                                                style="border-radius: 50%"
                                                                                @click="addAnswers(ct.category.id, k)"
                                                                            >
                                                                                <i class="fa fa-plus"></i>
                                                                            </button>
                                                                            <button
                                                                                v-if="k1 !== 0"
                                                                                type="button"
                                                                                class="btn btn-outline-danger btn-sm"
                                                                                style="border-radius: 50%"
                                                                                @click="removeAnswers(ct.category.id, k, k1)"
                                                                            >
                                                                                <i class="fa fa-minus"></i>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div class="col-sm-6 pr-0 col_right">
                                    <div class="accordion__template--condition table-responsive">
                                        <table class="table table-bordered table-box">
                                            <thead>
                                                <th>{{ $t('screenMaster.template.stt') }}</th>
                                                <th>{{ $t('screenMaster.template.nameShort') }}</th>
                                                <th>{{ $t('screenMaster.template.description') }}</th>
                                            </thead>
                                            <tbody>
                                                <template v-for="(itemList, idx) in listShortCode">
                                                    <template v-if="['0'].includes(itemList.id)">
                                                        <tr v-for="(itemData, k) in itemList.data" :key="`${k}-${idx}`">
                                                            <td class="colOne">
                                                                {{ itemData.id }}
                                                            </td>
                                                            <td class="colTwo">
                                                                <template v-if="Array.isArray(itemData.name_short)">
                                                                    <template v-for="(itemName, idxName) in itemData.name_short">
                                                                        <div
                                                                            v-b-tooltip.hover
                                                                            :title="itemName"
                                                                            :key="`shortName-${idxName}`"
                                                                            class="text-left mb-2"
                                                                            style="cursor: pointer"
                                                                            @click="clickInsertShortCode(itemName)"
                                                                        >
                                                                            {{ itemName }}
                                                                        </div>
                                                                    </template>
                                                                </template>
                                                                <template v-else>
                                                                    <div
                                                                        v-b-tooltip.hover
                                                                        :title="itemData.name_short"
                                                                        class="text-left mb-2"
                                                                        style="cursor: pointer"
                                                                        @click="clickInsertShortCode(itemData.name_short)"
                                                                    >
                                                                        {{ itemData.name_short }}
                                                                    </div>
                                                                </template>
                                                            </td>
                                                            <td class="text-left colThree">
                                                                <div class="row-data-large text-wrap" v-b-tooltip.hover :title="itemData.description">
                                                                    {{ itemData.description }}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                    <template v-else>
                                                        <tr :key="`${idx}`">
                                                            <td :colspan="3" class="p-0">
                                                                <b-button
                                                                    class="my-2 text-left p-1"
                                                                    block
                                                                    v-b-toggle="'shortCode_faq-' + `${idx}`"
                                                                    variant="light"
                                                                    style="max-width: 260px"
                                                                >
                                                                    {{ itemList.title }}
                                                                </b-button>
                                                                <b-collapse
                                                                    :id="'shortCode_faq-' + `${idx}`"
                                                                    accordion="my_shortCode_faq"
                                                                    role="tabpanel"
                                                                >
                                                                    <table class="table table-bordered table__collapse--template table-box">
                                                                        <tr v-for="(itemData, k) in itemList.data" :key="`${k}-${idx}`">
                                                                            <td class="colOne">
                                                                                {{ itemData.id }}
                                                                            </td>
                                                                            <td class="colTwo">
                                                                                <template v-if="Array.isArray(itemData.name_short)">
                                                                                    <template v-for="(itemName, idxName) in itemData.name_short">
                                                                                        <div
                                                                                            v-b-tooltip.hover
                                                                                            :title="itemName"
                                                                                            :key="`shortName-${idxName}`"
                                                                                            class="text-left mb-2"
                                                                                            style="cursor: pointer"
                                                                                            @click="clickInsertShortCode(itemName)"
                                                                                        >
                                                                                            {{ itemName }}
                                                                                        </div>
                                                                                    </template>
                                                                                </template>
                                                                                <template v-else>
                                                                                    <div
                                                                                        v-b-tooltip.hover
                                                                                        :title="itemData.name_short"
                                                                                        class="text-left mb-2"
                                                                                        style="cursor: pointer"
                                                                                        @click="clickInsertShortCode(itemData.name_short)"
                                                                                    >
                                                                                        {{ itemData.name_short }}
                                                                                    </div>
                                                                                </template>
                                                                            </td>
                                                                            <td class="text-left colThree">
                                                                                <div
                                                                                    class="row-data-large text-wrap"
                                                                                    v-b-tooltip.hover
                                                                                    :title="itemData.description"
                                                                                    v-html="convertNtoBr(itemData.description)"
                                                                                ></div>
                                                                            </td>
                                                                        </tr>
                                                                    </table>
                                                                </b-collapse>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </template>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer>
                <div v-if="!id" class="d-flex justify-content-center">
                    <div class="text-center flex-fill">
                        <button
                            type="button"
                            class="btn btn-common-footer mr-3"
                            @click="
                                $router.push({
                                    path: '/faqs'
                                })
                            "
                        >
                            {{ $t('btn.cancel') }}
                        </button>
                        <button
                            type="submit"
                            v-if="checkPermission('faq.register') || (checkPermission('faq.edit') && $route.query.id)"
                            class="btn btn-common btn-primary"
                            @click="formSubmit"
                        >
                            <i class="ri-file-add-line"></i>{{ $t('btn.register') }}
                        </button>
                    </div>
                </div>
                <div v-else class="d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center">
                        <div class="text-center flex-fill">
                            <button
                                type="button"
                                class="btn btn-common-footer mr-3"
                                @click="
                                    $router.push({
                                        path: '/faqs'
                                    })
                                "
                            >
                                <i class="ri-file-list-2-line"></i>{{ $t('btn.backList') }}
                            </button>
                            <button type="submit " @click="handleGetDetail" class="btn btn-common btn-info" style="min-width: 76px">
                                <i class="ri-arrow-left-line"></i>{{ $t('btn.goToDetail') }}
                            </button>
                        </div>
                    </div>
                    <button
                        type="submit"
                        v-if="checkPermission('faq.register') || (checkPermission('faq.edit') && $route.query.id)"
                        class="btn btn-common btn-success"
                        @click="formSubmit"
                    >
                        {{ $t('btn.save') }}
                    </button>
                </div>
            </Footer>
        </template>
        <div class="d-flex justify-content-center" v-else>
            <LoadingIcon />
        </div>
    </Layout>
</template>
<style lang="scss" scoped>
.col_left,
.col_right {
    max-height: 70vh;
    overflow: auto;
}
</style>
